var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"verify_email"},[_c('div',[_vm._v(" 確認のメールを送信しました メールのリンクをクリックして認証を完了してください ")])])}]

export { render, staticRenderFns }